/**
 * @generated SignedSource<<da1a19d114f34e7e1f06709e71f0422f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScrapSourceScrapsTaskRestoreInput = {
  scrapSource: string;
  scraps: ReadonlyArray<string>;
};
export type ScrapSourceScrapDeleteDialog_scrapSourceScrapsTaskRestoreMutation$variables = {
  input: ScrapSourceScrapsTaskRestoreInput;
};
export type ScrapSourceScrapDeleteDialog_scrapSourceScrapsTaskRestoreMutation$data = {
  readonly scrapSourceScrapsTaskRestore: {
    readonly id: string;
  };
};
export type ScrapSourceScrapDeleteDialog_scrapSourceScrapsTaskRestoreMutation = {
  response: ScrapSourceScrapDeleteDialog_scrapSourceScrapsTaskRestoreMutation$data;
  variables: ScrapSourceScrapDeleteDialog_scrapSourceScrapsTaskRestoreMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ScrapSource",
    "kind": "LinkedField",
    "name": "scrapSourceScrapsTaskRestore",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScrapSourceScrapDeleteDialog_scrapSourceScrapsTaskRestoreMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScrapSourceScrapDeleteDialog_scrapSourceScrapsTaskRestoreMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7d1fb957e9842229a8f41748c73e086f",
    "id": null,
    "metadata": {},
    "name": "ScrapSourceScrapDeleteDialog_scrapSourceScrapsTaskRestoreMutation",
    "operationKind": "mutation",
    "text": "mutation ScrapSourceScrapDeleteDialog_scrapSourceScrapsTaskRestoreMutation(\n  $input: ScrapSourceScrapsTaskRestoreInput!\n) {\n  scrapSourceScrapsTaskRestore(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f311d83178289eb8b8d3b03ae5693f70";

export default node;
